<template>
  <div class="content">
    <div class="ttile">
      客服
      <span>
        说明：默认悬浮展示在页面
      </span>
    </div>

    <div class="set-item">
      <p class="title">样式基础设置</p>
      <SpRadio
        v-model="curComponent.canDrop"
        size="big"
        label="是否可拖动"
        :options="canDropOptions"
      />
      <SpSlider v-model="curComponent.margin" label="左右边距" />
    </div>

    <div class="upload_content">
      <span>图片</span>
      <UploadImg v-model="curComponent.url" />
    </div>
  </div>
</template>

<script>
import SpRadio from "../../../components/SpRadio";
import SpSlider from "../../../components/SpSlider";

import UploadImg from "./components/UploadImg";
import { canDropOptions } from "./options";
export default {
  inject: ["control"],
  components: {
    SpRadio,
    SpSlider,
    UploadImg
  },
  computed: {
    curComponent() {
      return this.control.curComponent;
    }
  },
  data() {
    return {
      canDropOptions: Object.freeze(canDropOptions)
    };
  }
};
</script>

<style lang="less" scoped>
.content {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    span {
      font-size: 10px;
      color: #999999;
      margin-top: 4px;
    }
  }

  > .set-item {
    padding: 30px 24px 0px 24px;
    > .title {
      margin-bottom: 20px;
    }
    /deep/ .sp-radio {
      margin-bottom: 20px;
    }
  }

  > .upload_content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    margin-top: 20px;
    > span {
      font-size: 12px;
      color: #999999;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/CustomerService/Attr.vue